// api
import ModelService from '@/services/model.service'
import { mapState } from 'vuex'

export default {
  name: 'Milestones',
  data() {
    return {
      // 英语 中文 越南语 柬埔寨语 印尼语
      adIdList: [6, 17, 44, 61, 78],
      backIdList: [37, 38, 56, 73, 90],
      // data
      swiperSlides: '',
      backgroundInfo: '',
      groupMilestone: '',
      pictureItem:'',
      videoItem:'',
      galleryParams: [
        {
          param: {
            factoryName: 'Management'
          },
          query: {
            sid: 8,
            tid: 12,
            pid: 1407,
            vid: 1408,
          },
        },
        {
          param: {
            factoryName: 'Management'
          },
          query: {
            sid: 9,
            tid: 16,
            pid: 1409,
            vid: 1410,
          },
        },
        {
          param: {
            factoryName: 'Management'
          },
          query: {
            sid: 8,
            tid: 13,
            pid: 1411,
            vid: 1412,
          },
        },
        {
          param: {
            factoryName: 'Management'
          },
          query: {
            sid: 8,
            tid: 14,
            pid: 1413,
            vid: 1414,
          },
        },
        {
          param: {
            factoryName: 'Management'
          },
          query: {
            sid: 9,
            tid: 17,
            pid: 1415,
            vid: 1416,
          },
        },
        {
            param: {
                factoryName: 'Management'
            },
            query: {
                sid: 10,
                tid: 18,
                pid: 1419,
                vid: 1420,
            },
        },
        {
          param: {
            factoryName: 'Management'
          },
          query: {
            sid: 8,
            tid: 15,
            pid: 1417,
            vid: 1418,
          },
        },
        {
          param: {
            factoryName: 'Management'
          },
          query: {
            sid: 10,
            tid: 19,
            pid: 1421,
            vid: 1422,
          },
        },
        {
          param: {
            factoryName: 'Management'
          },
          query: {
            sid: 5,
            tid: 11,
            pid: 1423,
            vid: 1424,
          },
        },
        {
          param: {
            factoryName: 'Management'
          },
          query: {
            sid: 5,
            tid: 2010,
            pid: 2047,
            vid: 2048,
          },
        },
        
      ],
    };
  },
  computed: mapState({
    ...mapState(['isPC', 'language', 'LangIndex'])
  }),
  watch: {
    LangIndex: {
      handler(str) {
        this.init();
      },
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.getAdPictureList();
      this.getbackgroundInfo();
      this.getPageInfo();
      this.initBtnName();
    },
    initBtnName(){
      if(this.LangIndex === 1){
          this.pictureItem = '图片';
          this.voideItem = '视频';
      }else{
          this. pictureItem = 'Picture';
          this. voideItem = 'Video';
      }

    },

    // 根据id获取页面内容
    // http://www.epfootwear.com:8080/api/content/list?lang=EN&module=groupmilestone&type=2
    getPageInfo() {
      const param = {
        lang: this.language,
        module: 'project',
        type: 2
      };
      ModelService.getContentList(param).then((res) => {
        if (res.code === 0) {
          this.groupMilestone = this.even(res.data);
          //console.log(this.groupMilestone, res.data);
        }
      });
    },
    // 根据id获取广告图片
    getAdPictureList() {
      const param = {
        lang: this.language,
        adId: this.adIdList[this.LangIndex],
      };
      ModelService.getbanner(param).then((res) => {
        if (res.code === 0) {
          this.swiperSlides = res.data[0];
        }
      });
    },
    // 根据id获取背景图片
    getbackgroundInfo() {
      const param = {
        lang: this.language,
        adId: this.backIdList[this.LangIndex],
      };
      ModelService.getbanner(param).then((res) => {
        if (res.code === 0) {
          this.backgroundInfo = res.data[0];
        }
      });
    },
    // 清洗数据
    even(arr) {
      arr.forEach(item => {
        item.status = false;
      });
      return arr;
    },
    // 跳转对应相册
    goGalleryPage(index, type) {
      const urls = this.galleryParams[index];
      const query = {
        sid: urls.query['sid'],
        tid: urls.query['tid'],
        gid: urls.query[type]
      }
      this.$tools.go({
        name: 'Gallery',
        params: urls.param,
        query: query,
      });
    },
    openTips(index) {
      let data = this.even(this.groupMilestone);
      data[index].status = true;
      this.groupMilestone = data;
    },
    closeTips(index) {
      let data = this.groupMilestone;
      data[index].status = false;
      this.groupMilestone = data;
    },
  },
};
